module.exports = __webpack_public_path__ + "static/media/2-3-mobile.b64cedb8.webp";